import { render, staticRenderFns } from "./FacebookAuth.vue?vue&type=template&id=8e8198b8&scoped=true&"
import script from "./FacebookAuth.vue?vue&type=script&lang=js&"
export * from "./FacebookAuth.vue?vue&type=script&lang=js&"
import style0 from "./FacebookAuth.vue?vue&type=style&index=0&id=8e8198b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e8198b8",
  null
  
)

export default component.exports